import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { styled } from '@mui/material/styles';

export const DoNotDisturbAltIconStyled = styled(DoNotDisturbAltIcon)(({ theme }) => ({
  color: theme.palette.error.light,
}));

export const CheckIconStyled = styled(CheckIcon)(({ theme }) => ({
  color: theme.palette.success.light,
}));
